/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'goal-actions.archive-goal.generic-error-title': 'ゴールをアーカイブできませんでした',
  'goal-actions.copy-goal.cancel': 'キャンセル',
  'goal-actions.copy-goal.close-modal': 'モーダルを閉じる',
  'goal-actions.copy-goal.error': 'ゴールの内容をわかりやすく表す名前を付けてください',
  'goal-actions.copy-goal.failed-description': 'ゴールの複製中にエラーが発生しました。後でもう一度お試しください。',
  'goal-actions.copy-goal.failed-description-forbidden': 'このゴールをコピーする権限がありません。',
  'goal-actions.copy-goal.failed-title': 'このゴールを複製できませんでした。',
  'goal-actions.copy-goal.followers': 'フォロワー',
  'goal-actions.copy-goal.goal-name': 'ゴール名',
  'goal-actions.copy-goal.include': '含める',
  'goal-actions.copy-goal.links': 'リンク',
  'goal-actions.copy-goal.submit': '送信',
  'goal-actions.copy-goal.success-description': 'ゴールは正常に複製されました。',
  'goal-actions.copy-goal.success-link': '複製されたゴールを表示します。',
  'goal-actions.copy-goal.success-title': 'ゴール「{goalName}」が複製されました。',
  'goal-actions.copy-goal.title': 'ゴールをコピー',
  'goal-actions.follow-goal.follow-error-title': 'ゴールをフォローできませんでした',
  'goal-actions.follow-goal.unfollow-error-title': 'ゴールのフォローを解除できませんでした',
  'goal-actions.goal-actions.archive-error-title': 'ゴールを復元できませんでした',
  'goal-actions.goal-actions.archive-goal': 'ゴールをアーカイブ',
  'goal-actions.goal-actions.archive-restore-error-description':
    'ゴールの変更を保存できませんでした。後でもう一度お試しください。',
  'goal-actions.goal-actions.copy-goal': 'ゴールをコピー',
  'goal-actions.goal-actions.copy-link': 'リンクをコピー',
  'goal-actions.goal-actions.follow': 'フォロー',
  'goal-actions.goal-actions.generic-error-description': '問題が発生しました。しばらくしてから再度お試しください。',
  'goal-actions.goal-actions.restore-goal': 'ゴールを復元',
  'goal-actions.goal-actions.share': '共有',
  'goal-actions.goal-actions.show-more': 'さらに表示',
  'goal-actions.goal-actions.unfollow': 'フォローを解除',
  'goal-actions.goal-content.follow-confirmation-description':
    '翌月の最初の週に、フォロー中のすべてのゴールに関する最新情報を含むダイジェストが届きます。',
  'goal-actions.goal-content.follow-confirmation-title': '🙌🏼 このゴールをフォロー中です!',
  'goal-actions.restore-goal.generic-error-title': 'ゴールを復元できませんでした',
};
